import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import { NgxStarsModule } from "ngx-stars";
import {StarRatingComponent} from "./star-rating.component";


@NgModule({
  declarations: [StarRatingComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    NgxStarsModule,
  ],
  exports: [
    StarRatingComponent
  ]
})
export class StarRatingModule {
}
